import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../../api/api";

export const getSettingsThunk = createAsyncThunk("settings/get", async (_, { rejectWithValue }) => {
  try {
    const res = await api.getSettings();
    return res.data;
  } catch (err) {
    return rejectWithValue(err?.message || "Could not load settings");
  }
});

const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    data: null,
    is_loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSettingsThunk.pending, (state) => {
        state.is_loading = true;
      })
      .addCase(getSettingsThunk.fulfilled, (state, action) => {
        state.is_loading = false;
        state.data = action.payload;
      })
      .addCase(getSettingsThunk.rejected, (state) => {
        state.is_loading = false;
      });
  },
});

export default settingsSlice.reducer;
